import { useState, useEffect } from 'react';
import { usePOS } from '../context/POSContext';

function SearchBar() {
  const { setSearchQuery } = usePOS();
  const [localSearch, setLocalSearch] = useState('');

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      setSearchQuery(localSearch.trim());
    }, 300);

    return () => clearTimeout(debounceTimer);
  }, [localSearch, setSearchQuery]);

  return (
    <div className="relative max-w-md mx-auto mb-6">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <svg
          className="h-5 w-5 text-gray-400"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
            clipRule="evenodd"
          />
        </svg>
      </div>
      <input
        type="text"
        className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md bg-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 text-sm"
        placeholder="Rechercher des produits..."
        value={localSearch}
        onChange={(e) => setLocalSearch(e.target.value)}
      />
    </div>
  );
}

export default SearchBar;